module.exports = __webpack_public_path__ + "img/magazin-header@2x.0ddd98d5.jpg";